import { useEffect, useRef } from 'react';

export const DefaultScrollConfig = {
  behavior: 'smooth',
  block: 'nearest',
  inline: 'start',
};

export const scrollToRef = (ref) =>
  ref.current?.scrollIntoView(DefaultScrollConfig);

const useScrollOnMount = () => {
  const ref = useRef(null);

  useEffect(() => {
    scrollToRef(ref);
  }, []);

  return ref;
};

export default useScrollOnMount;
